import React, { useEffect, useState } from "react";
import usePresale from "../../../hooks/usePresale";

export default function PricePerToken() {
  const { round, preSaleRate, totalHardCap, ICOInfo } = usePresale();
  const [saleRound, setSaleRound] = useState([]);
  const [presaleRate, setPresaleRate] = useState(0);
  const [totalToken, setTotalToken] = useState(0);
  const [USDPrice, setUSDPrice] = useState(0);
  const [IcoInfo, setIcoInfo] = useState([]);
  useEffect(() => {
    const info = async () => {
      await preSaleRate().then((data) => {
        console.log(data);
        setPresaleRate(data);
      });
      await ICOInfo().then((data) => {
        // console.log(data);
        setIcoInfo(data);
      });
      await round().then((data) => {
        // console.log(data);
        setSaleRound(data);
      });
      await totalHardCap().then((data) => {
        // console.log(data);
        setTotalToken(data);
      });
      // getLivePriceOfMarket("ETH").then((data) => setUSDPrice(data));
    };
    info();
  }, []);
  return (
    <div>
      <section className="lg:pt-[100px] text-white py-[25px]">
        <div className="container lg:px-10 px-4">
          <div className="bg-[#751efe] shadow-blue rounded-[10px] lg:px-[80px] px-3 py-8">
            <div className="flex lg:flex-row flex-col justify-between mb-8 items-center">
              <div>
                <p className="mb-3 font-bold">
                  {/*} Current Price = {parseInt(presaleRate) / 10000} USD*/}
                  Current Price = 0.011 USD
                </p>
                <p className="font-bold text-[13px]">
                  Total Sold:
                  <span className="font-bold lg:text-[22px] text-[18px] ml-3">
                    {parseFloat(parseInt(IcoInfo[1]) / 1e18).toFixed(2)} LRN
                  </span>
                </p>
              </div>
              <div className="lg:mt-0 mt-8">
                <p className="mb-3 font-bold flex lg:justify-end justify-center">
                  {saleRound[0]}
                </p>
                <p className="font-bold">{parseInt(totalToken) / 1e18} LRN</p>
              </div>
            </div>
            <div className="w-full bg-[#818ab0] h-2.5">
              <div
                className="bg-white h-2.5"
                style={{
                  width: `${
                    (parseInt(IcoInfo[1]).toFixed(2) / parseInt(totalToken)) *
                    100
                  }`,
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
